module.exports = __webpack_public_path__ + "img/19 Spätuf Nageln (1).jpg";